module.exports = __webpack_public_path__ + "img/lsbanner.cc94d709.png";